<script setup>

import Search from "./SpeakersList/Search.vue";
import List from "./SpeakersList/List.vue";
import Pagination from "./SpeakersList/Pagination.vue";
import Repository from "./Helpers/Repository";
import {onMounted, ref} from "vue";
import Spinner from "./Spinner.vue";

const DEFAULT_SEARCH_COUNT = 30;

onMounted(() => {
    refreshSpeakers();
});

const speakers = ref(null);
const paginationMeta = ref({});
const currentPage = ref(1);
const search = ref(null);
const enablePaginationNav = ref(false);

const changePage = (page) => {
    currentPage.value = page;
    refreshSpeakers();
}

const refreshSpeakers = () => {
    new Repository().getSpeakers(currentPage.value, search.value, DEFAULT_SEARCH_COUNT).then((response) => {
        const totalPages = parseInt(response.headers['x-wp-totalpages']);
        speakers.value = response.data;

        paginationMeta.value = {
            last_page: totalPages,
        };

        document.documentElement.scrollTop = 0;

        enablePaginationNav.value = totalPages > 1;
    });
}

const searchSpeakers = (search_speakers) => {
    search.value = search_speakers;
    currentPage.value = 1;
    refreshSpeakers()
}

</script>

<template>
    <Search @submit="searchSpeakers"/>
    <Spinner v-if="speakers === null"/>
    <template v-else>
        <List :speakers="speakers"/>
        <Pagination v-if="enablePaginationNav" :meta="paginationMeta" @changePage="changePage"
                    :currentPage="currentPage"/>
    </template>
</template>
